import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Feather } from 'lucide-react'
import { buttonClass } from '@/components/generals/button'
import { Reveal } from '@/components/generals/reveal'

interface ShareCtaSectionProps {
    title?: string
    text?: string
    href?: string
}

const ShareCtaSection: FC<ShareCtaSectionProps> = ({
    title = "Do you remember something we should keep?",
    text = "A nickname, a recipe, a photo you can describe, the town someone was born in. The smallest detail can complete a branch of the tree.",
    href = '/share'
}): ReactNode => {
    return (
        <section id='share-a-memory' className='px-5 pt-8 pb-24 md:px-8'>
            <Reveal className='relative mx-auto max-w-6xl overflow-hidden rounded-[2rem] bg-forest px-8 py-14 text-center text-linen md:px-16 md:py-20'>
                <span aria-hidden='true' className='absolute -top-24 -right-20 size-72 rounded-full border border-linen/15' />
                <span aria-hidden='true' className='absolute -bottom-28 -left-16 size-80 rounded-full border border-linen/10' />

                <Feather className='relative mx-auto size-8 text-gold' aria-hidden='true' />

                <h2 className='relative mx-auto mt-6 max-w-2xl font-heading text-3xl leading-tight font-semibold text-balance md:text-5xl'>
                    {title}
                </h2>

                <p className='relative mx-auto mt-5 max-w-xl text-lg leading-relaxed text-linen/80'>
                    {text}
                </p>

                <Link href={href} className={buttonClass({ variant: 'light', size: 'lg', className: 'relative mt-10' })}>
                    Share a memory
                </Link>
            </Reveal>
        </section>
    )
}

export default ShareCtaSection
